
/**
 * Modela de producto de una fichada.
 *
 * @export
 * @class Product
 */
export class Product{

    /**
     * Contiene el nombre del producto.
     *
     * @private
     * @type {string}
     * @memberof Product
     */
    private _name: string = '';


    /**
     * Contiene el código del producto.
     *
     * @private
     * @type {string}
     * @memberof Product
     */
    private _code: string = '';


    /**
     * Contiene el id interno de la Of relacionada con el producto.
     *
     * @private
     * @type {string}
     * @memberof Product
     */
    private _of: string = '';


    /**
     * Crea una instancia de Product.
     * 
     * @param {*} [params={}]
     * @memberof Product
     */
    constructor(params:any = {}){
        //Objeto Producto
        if(typeof params.code != 'undefined') this._code = params.code;
        if(typeof params.name != 'undefined') this._name = params.name;
        if(typeof params.of != 'undefined') this._of = params.of;
        //Respuesta JSON
        if(typeof params.id_reg_ofsproductos != 'undefined') this._code = params.id_reg_ofsproductos;
        if(typeof params.producto != 'undefined') this._name = params.producto;
        if(typeof params.id_reg_ofs != 'undefined') this._of = params.id_reg_ofs;
    }

    /**
     * Nombre getter.
     *
     * @type {string}
     * @memberof Product
     */
    get name(): string{
        return this._name;
    }

    /**
     * Nombre setter.
     *
     * @memberof Product
     */
    set name(name: string){
        this._name = name;
    }

    /**
     * Código getter.
     *
     * @type {string}
     * @memberof Product
     */
    get code(): string{
        return this._code;
    }

    /**
     * Código setter.
     *
     * @memberof Product
     */
    set code(code: string){
        this._code = code;
    }

    /**
     * Id interno de la OF getter.
     *
     * @type {string}
     * @memberof Product
     */
    get of(): string{
        return this._of;
    }

    /**
     * Id interno de la OF setter.
     *
     * @memberof Product
     */
    set of(of: string){
        this._of = of;
    }

    /**
     * Nombre de producto getter.
     *
     * @readonly
     * @type {string}
     * @memberof Product
     */
    get product(): string{
        return this._name;
    }

}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/product.model.ts